<template>
  <table class="v-table theme--light">
    <thead>
    <tr>
      <th v-bind:style="{ width: '50px' }"></th>
      <th v-bind:style="{ width: '400px' }">Service title</th>
      <th>Code</th>
      <th>Price</th>
      <th>Requested Quantity</th>
      <th>Executed Quantity</th>
      <th>Comment</th>
      <th>Actions</th>
    </tr>
    <tr class="v-datatable__progress" v-show="processing">
      <th colspan="7" class="column">
        <template>
          <v-progress-linear height="1" color="primary" :indeterminate="true"></v-progress-linear>
        </template>
      </th>
    </tr>
    </thead>
    <tbody>
      <case-service-item v-for="resultService in resultServicesPresentation"
                         v-bind:item="resultService"
                         v-bind:key="resultService.uiId"
                         @startProcessing="handleStartProcessing"
                         @stopProcessing="handleStopProcessing"
                         @removedServiceFromCase="handleRemoveServiceFromCase"
                         @addedServiceToCase="handleAddServiceToCase"
                         @updatedCaseService="handleUpdateCaseService"
                         @casePriceUpdated="handleUpdateCasePrice"
                         @requestedQuantityChanged="handleRequestedQuantityChanged"
                         @executedQuantityChanged="handleExecutedQuantityChanged">
      </case-service-item>
    </tbody>
  </table>
</template>

<script>
import _ from 'lodash'
import CaseServiceItem from './CaseServiceItem'

export default {
  name: 'case-services',
  props: {
    case: {
      type: Object
    },
    availableCaseServices: {
      type: Array
    },
    caseServices: {
      type: Array
    },
    servicesById: {
      type: Object
    },
    filters: {
      type: Object
    }
  },
  components: {
    CaseServiceItem
  },
  data () {
    return {
      processing: false
    }
  },
  computed: {
    caseServicesById () {
      return _.keyBy(this.caseServices, 'serviceId')
    },
    resultServices () {
      let services = []

      for (let availableCaseService of this.availableCaseServices) {
        let service = this.servicesById[availableCaseService.serviceId]

        if (!service) {
          continue
        }

        let item = {
          id: null,
          quantity: null,
          executedQuantity: null,
          uiId: availableCaseService.serviceId,
          title: _.get(service, 'title', '-'),
          code: _.get(service, 'code', '-'),
          addedToCase: false,
          defaultPrice: availableCaseService.price,
          defaultCurrency: availableCaseService.currency,
          priceOverridden: false,
          price: null,
          currency: null,
          comment: null,
          caseId: this.case.id,
          serviceId: availableCaseService.serviceId
        }

        let caseService = this.caseServicesById[availableCaseService.serviceId]
        if (caseService) { // populate actual data
          item.addedToCase = true
          item.id = caseService.id
          item.quantity = caseService.quantity
          item.executedQuantity = caseService.executedQuantity
          item.priceOverridden = caseService.priceOverridden
          item.clientServiceVersion = caseService.clientServiceVersion

          if (caseService.price) {
            item.price = caseService.price
            item.currency = caseService.currency
          }

          if (caseService.comment) {
            item.comment = caseService.comment
          }
        }

        if (!caseService && availableCaseService.hidden) {
          continue
        }

        services.push(item)
      }

      return services
    },
    filteredResultServices () {
      let titleOrCodeFilter = _.get(this.filters, 'titleOrCode', '')
      if (titleOrCodeFilter === '') {
        return this.resultServices
      }

      return _.filter(this.resultServices, function (item) {
        let titleResult = _.toLower(item.title).indexOf(_.toLower(titleOrCodeFilter))

        if (titleResult >= 0) {
          return true
        }

        return item.code.includes(titleOrCodeFilter)
      })
    },
    resultServicesPresentation () {
      let sorted = _.orderBy(this.filteredResultServices, ['addedToCase', 'code'], ['desc', 'asc'])

      return sorted
    }
  },
  mounted () {

  },
  methods: {
    handleStartProcessing () {
      this.processing = true
    },
    handleStopProcessing () {
      this.processing = false
    },
    handleRemoveServiceFromCase (result) {
      this.$emit('removedServiceFromCase', result)
    },
    handleAddServiceToCase (addedItem) {
      this.$emit('addedServiceToCase', addedItem)
    },
    handleUpdateCaseService (updatedItem) {
      this.$emit('updatedCaseService', updatedItem)
    },
    handleUpdateCasePrice (updatedItem) {
      this.$emit('casePriceUpdated', updatedItem)
    },
    handleRequestedQuantityChanged(event) {
      this.$emit('requestedQuantityChanged', event)
    },
    handleExecutedQuantityChanged(event) {
      this.$emit('executedQuantityChanged', event)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/CaseServices.vue